// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-brands-brand-item-item-bysvq{background:var(--color-grayLight);padding:12px}.components-brands-brand-item-item-bysvq:hover{background:rgba(var(--color-grayLight),.75)}.components-brands-brand-item-image-wqigt{border-radius:6px;display:block;line-height:0;overflow:hidden;padding-top:56.25%;position:relative}.components-brands-brand-item-imageInner-bengq{transition:all .1s ease-in-out;right:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-brands-brand-item-item-bysvq",
	"image": "components-brands-brand-item-image-wqigt",
	"imageInner": "components-brands-brand-item-imageInner-bengq"
};
module.exports = ___CSS_LOADER_EXPORT___;
